import React from 'react';
import { useTranslation } from 'react-i18next';
import { FitoListReactQuery } from '~/Components';
import { StudioCreationTour } from '~/Components/ProductTours/tours/StudioCreationTour';
import { AccessList, useHasAccess } from '~/Hooks';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useProviderLocations } from '.';
import { Route } from '~/Constants/Routes.constants';
import { useLocationsListDesktopTableDefinition } from './useLocationsListDesktopTableDefinition';
import { useLocationListWithStatus, useBackendLocationSearch } from '~/Hooks/useLocationsList';
import { ILocationWithStatus } from '~/Models/interfaces/Location.model';
import { useProviderLocationsActions } from './useProviderLocationsActions';

export const ProviderLocations = () => {
  const { hasAccess } = useHasAccess();

  const { t } = useTranslation();
  const {
    keyOfId,
    settings,
    setItemValues,
    goToLocationCreation,
    title,
    defaultQuery,
  } = useProviderLocations();

  const { actions } = useProviderLocationsActions();

  const LocationsListDesktopTableDefinition = useLocationsListDesktopTableDefinition();

  const canCreateLocation = hasAccess(Route.ORGANISATION_STUDIO_CREATE);
  const canCopyLocation = hasAccess(AccessList.COPY_LOCATION);

  const pageTile = canCreateLocation
    ? {
        title: t('settings.locations'),
        onAddButtonClick: goToLocationCreation,
        actionName: t('settings.locations.add'),
      }
    : {
        title: t('settings.locations'),
      };

  return (
    <PrivateLayout title={pageTile} hideBackButton>
      <StudioCreationTour />
      <FitoListReactQuery<ILocationWithStatus>
        keyOfId={keyOfId}
        settings={settings}
        title={title}
        setItemValues={setItemValues}
        tableDefinition={LocationsListDesktopTableDefinition}
        pageSize={10}
        queryResults={useLocationListWithStatus}
        defaultQuery={defaultQuery}
        searchTextPlaceholder={t('app.search.locations')}
        actions={canCopyLocation ? actions : undefined}
        infiniteScroll
        backendSearch={useBackendLocationSearch}
      />
    </PrivateLayout>
  );
};
